<template>
	<div>
	   <el-row style="height:80px;">
	     <el-col :span="16">
			 <div class="navlist">
				   <h1>石油</h1>
				   <router-link to="/demandHome/demandIndex" active-class="active-link">首页</router-link>
				   <router-link to="/demandHome/demandOrder" active-class="active-link">我的订单</router-link>
				   <router-link to="/demandHome/demandinvitedList"  active-class="active-link">邀标记录</router-link>
				   <el-dropdown>
						<span class="nav-item" :class="{ 'active-link': isPersonalCenterActive }">个人中心<i class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link to="/demandHome/demandPromotion" active-class="active-link">
									我的推荐
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/demandHome/demandinvoiceList" active-class="active-link">
									历史开票
								</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/demandHome/demandUserInfo" active-class="active-link">
									个人信息
								</router-link>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
			 </div>  
		</el-col>
	    <el-col :span="4" style="display:flex;">
			 <el-button type="primary" icon='el-icon-plus' round @click="xuqiu">发布需求</el-button>
			 <div class="disng">
				<img src="@/assets/lingdan.png" alt="" sizes="" srcset=""   class="disng1" @click="message"/>
				<img :src="userinfo.avatar" alt="" sizes="" srcset=""   class="disng2"/>
			 </div>
		</el-col>
	   </el-row>
	   <el-dialog
	     title="发布需求"
	     :visible.sync="centerDialogVisible"
	   	 :close-on-click-modal="false"
	     width="810px">
	     <div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
			  <el-form-item label="需求标题" prop="name">
			    <el-input v-model="ruleForm.name"></el-input>
			  </el-form-item>
			  <el-form-item label="选择行业" prop="value">
			    <el-select v-model="ruleForm.value"   
				           multiple
	                       :multiple-limit="5" 
						   placeholder="请选择活动区域" style="width:100%;">
			       <el-option :label="i.name" :value="i.dict_value" v-for="(i,index) in industry" :key="index"></el-option>
			    </el-select>
			  </el-form-item>
			  <el-form-item label="详细描述" prop="desc">
			    <el-input type="textarea" v-model="ruleForm.description"></el-input>
			  </el-form-item>
			  <el-form-item label="报价截止时间" required>
			    <el-col :span="24">
			      <el-form-item prop="end_time">
					 <el-date-picker
					     v-model="ruleForm.end_time"
						  style="width: 100%;"
					      type="datetime"
					      placeholder="选择日期时间">
					    </el-date-picker>
			      </el-form-item>
			    </el-col>
			  </el-form-item>
			  <el-form-item label="附件上传" v-if="demand_file_config==1">
				   <el-upload
				     class="upload-demo"
				     :action="uploadActionUrl"
				     :on-preview="handlePreview"
				     :on-remove="handleRemove"
				     :on-success="handleUploadSuccess"
				     :before-remove="beforeRemove"
				     multiple
				     :limit="4"
				     :on-exceed="handleExceed"
				     :file-list="fileList">
					 <div>
						<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
						<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
							 单个文件最大支持10M，最多不超过四个文件
						</span>
					 </div>
				   </el-upload>
			  </el-form-item>
			</el-form>
			<div class="fbfooter">
				 <div class="fbfooter1">取消</div> 
				 <div class="fbfooter2" @click="submitForm('ruleForm')">立即发布</div>
			</div>
		 </div>
	   </el-dialog>
	   <router-view></router-view>
	   <!-- :close-on-click-modal="false" -->
	</div>
</template>

<script>
    import config from '@/config/index'
	import { personal,BaseGetConfig,dictValue,DemandAdd,Demandupdate} from '@/api/api'
	
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
		  baseURL:config.baseURL,
		  centerDialogVisible:false,
		  ruleForm: {
			value:"",
			i_ids:"",
			name: '',
			description:"",
			end_time:"",
			file:[]
		  },
		  fileList:[],
		  userinfo:"",
		  rules: {
			name: [
			  { required: true, message: '请输入需求标题', trigger: 'blur' },
			],
			value: [
			  { required: true, message: '请选择行业', trigger: 'change' }
			],
			end_time: [
			  { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
			],
			reject_reason: [
			  { required: true, message: '请填写需求详情', trigger: 'blur' }
			]
		  },
		  demand_file_config:"",
		  demand_off_time:"",
		  industry:""
	    }
	  },
	  computed: {
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
			// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			}
	  },
	  created() {
	  	 this.getpersonal()
		 this.getBaseGetConfig()
		 this.getdictValue()
	  },
	  methods: {
		handleExceed(files, fileList) {
		  this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  // 兼容常见返回结构：
		  // 1) { data: { data: { url/file } } }
		  // 2) { data: { url/file } }
		  // 3) { data: "url" } / { data: ["url"] }
		  // 4) { url/file } / "url"
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.ruleForm.file.includes(uploadedUrl)
			if (!exists) this.ruleForm.file.push(uploadedUrl)
		  }
		},
		beforeRemove(file, fileList) {
		  return this.$confirm(`确定移除 ${file.name}？`)
		},
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.ruleForm.file = this.ruleForm.file.filter((url) => url !== removedUrl)
		},
		handlePreview(file) {
		  console.log(file)
		},
		getdictValue(){
		  	dictValue({
		  		key:"industry"
		  	}).then(res=>{
		  		this.industry=res.data.data.industry
		  		// this.work_year.forEach(item =>{
		  		// 	item.text=item.name
		  		// })
		  	})
		},
		getBaseGetConfig(){
		  	BaseGetConfig({
		  		key:"demand_file_config,demand_off_time"
		  	}).then(res=>{
		  		this.demand_file_config=res.data.data.demand_file_config
		  		this.demand_off_time=res.data.data.demand_off_time
		  	})
		},
		getpersonal(){
			personal({}).then(res=>{
				this.userinfo=res.data.data
				localStorage.setItem("userinfo",this.userinfo)
			})
		},
	    xuqiu(){
			 this.centerDialogVisible=true
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
			    // this.DemandAdd(this.ruleForm)
				this.setDemandAdd()
			  } else {
			    console.log('error submit!!')
			    return false
			  }
			})
		},
		setDemandAdd(){
			this.ruleForm.file=[]
			console.log(this.fileList)
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
					this.ruleForm.file.push(res.response.data)
				})
			}
			this.ruleForm.i_ids=this.ruleForm.value.join()
			DemandAdd({
				...this.ruleForm
			}).then(res=>{
				if(res.data.status==200){
					this.$message.success('提交成功');
					this.centerDialogVisible=false
			
				}else{
					this.$message.error(res.data.msg);
				}
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		message(){
			if (this.$route.path !== '/demandHome/messagelist') {
			    this.$router.push('/demandHome/messagelist')
			}
		}
	  },
	}
</script>

<style scoped>
	.el-row {
		width:100%;
		background-color:#fff;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.active-link{
		color:#1E3A8A ;
	}
	.navlist{
		display:flex;
		align-items: center;
	}
	.navlist a{
		font-weight: bold;
		font-size: 20px;
		margin-left:72px;
		color:#999999;
	}
	.nav-item {
	  font-weight: bold;
	  font-size: 20px;
	  margin-left: 72px;
	  cursor: pointer;
	  display: inline-flex;
	  align-items: center;
	}
	
	.nav-item .el-icon-arrow-down {
	  font-size: 14px;
	  margin-left: 4px;
	}
	::v-deep .el-dropdown{
		color:#999999;
	}
	::v-deep .active-link{
	    color: #1E3A8A !important;
	}
	::v-deep .el-dialog__body {
	    padding: 0px 20px 20px;
	}
	::v-deep .el-dialog{
		border-radius:6px !important;
	}
	.fbfooter{
		display:flex;
		justify-content:center;
		align-items: center;
	}
	.fbfooter div{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px 8px 8px 8px;
		display:flex;
		align-items:center;
		justify-content:center;
		margin:20px;
		cursor:pointer;
		color:#1E3A8A;
	}
	.fbfooter2{
		background: #1E3A8A !important;
		color:#fff !important;
	}
	.disng{
		display:flex;
		align-items: center;
	}
	.disng1{
		width:24px;
		height:24px;
		margin-left:24px;
		cursor:pointer;
	}
	.disng2{
		width:32px;
		height:32px;
		border-radius:50%;
		margin-left:24px;
		cursor:pointer;
	}
</style>